module.exports = __webpack_public_path__ + "static/media/anatomia.54a6812d.png";